// extracted by mini-css-extract-plugin
export default {"add_button":"AddButton_add_button__oT1n1"};